export const getTopLevelLocale = (localeCode: string) => localeCode.split('-')[0]
